import Visualizer from './components/Visualizer';

const App = () => {
  return (
    <div className="App">
      <Visualizer />
    </div>
  );
}

export default App;